import styled from "styled-components";

export const ValidationNoInput = () => {
    return null;
};

export const StyledInput = styled.div`
    width: 200px;
`;
